/* eslint-disable @typescript-eslint/no-empty-interface */
import {OrderResponse, OrderResponseWithSample} from './order-response.model';

export type Order = OrderResponse | OrderResponseWithSample;

export const isOrderWithSample = (order: Order): order is OrderResponseWithSample => {
  return 'sample' in order;
};
